import api from "../api";

const controller = '/naoPrevisto';

export interface InboxPendenciaProps {
  solicitacaoNaoPrevistoId: string;
  projeto: string;
  solicitante: string;
  responsavel: string;
  statusSolicitacao: string;
  statusAprovacao: string;
  stepHash: string;
  tipoPendencia: 'VALIDACAO' | 'APROVACAO';
}

export const getInboxPendencias = async (): Promise<InboxPendenciaProps[]> => {
  // `createApi` (Digital UI) retorna o `data` diretamente no get.
  const data = await api.get<InboxPendenciaProps[]>(`${controller}/caixaEntrada`);
  return Array.isArray(data) ? data : [];
}
